export default {
      id: "report-green-usage",
      viewBox: "0 0 19 19",
      url: "/" + "sprite.svg#report-green",
      toString: function () {
        return this.url;
      }
    }